module.exports = __webpack_public_path__ + "img/vergil_photo.5192dd11.jpg";